import { Button, Stack, Typography } from "@compass/core";
import { SubmitButton } from "components";
import { ScreenType } from "./ObjectiveReportPage";

export const ObjectiveReportPageHeader = (props: {
  handle: string;
  screen: ScreenType;
  setScreen: (screen: ScreenType) => void;
  generateReport: () => void;
}) => {
  return (
    <Stack direction="row" justifyContent="space-between">
      <Typography variant="inherit">{props.handle}</Typography>

      <Stack direction="row" alignItems="center" spacing="sm">
        {props.screen === "report" && (
          <Button variant="outlined" onClick={(e) => props.setScreen("config")}>
            Back
          </Button>
        )}

        {props.screen === "config" && <SubmitButton onClick={props.generateReport} label={"Generate Report"} />}
      </Stack>
    </Stack>
  );
};
